import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import DoSurvey from "./pages/surveys/DoSurvey";
import Login from "./pages/login/Login";
import Signup from "./pages/signup/Signup";
import Welcome from "./pages/welcome/Welcome";
import "./pages/surveys/cards.css";
import "./pages/surveys/createSurvey.css";
import StepOne from "./pages/surveys/StepOne";
import StepTwo from "./pages/surveys/StepTwo";
import StepThree from "./pages/surveys/StepThree";
import StepFour from "./pages/surveys/StepFour";
import StepFive from "./pages/surveys/StepFive";
import StepSix from "./pages/surveys/StepSix";
import Step7 from "./pages/surveys/Step7";
import Step8 from "./pages/surveys/Step8";
import Step9 from "./pages/surveys/Step9";
import Step10 from "./pages/surveys/Step10";
import Step11 from "./pages/surveys/Step11";
import Step12 from "./pages/surveys/Step12";
import Step13 from "./pages/surveys/Step13";
import Step14 from "./pages/surveys/Step14";
import Step15 from "./pages/surveys/Step15";
import Result from "./pages/result/Result";
import ConfirmRegistration from "./pages/signup/ConfirmRegistration";
import ScrollToTop from "./components/ScrollToTop";
import ForgotPassword from "./pages/resetPassword/ForgotPassword";
import ResetPassword from "./pages/resetPassword/ResetPassword";
import SurveyUnavailable from "./pages/surveys/SurveyUnavailable";
import { useEffect } from "react";
import DoManagerSurvey from "./pages/surveys/DoManagerSurvey";
import ISPDashboard from "./pages/ispDashboard/ISPDashboard";

const PrivateRoute = ({ children }) => {
  const isAuthenticated = JSON.parse(localStorage.getItem("companyData"));

  if (isAuthenticated) {
    return children;
  }

  return <Navigate to="/Login" replace />;
};

const App = () => {
  useEffect(() => {
    const clearLocalStorage = () => {
      localStorage.clear();
    };

    window.addEventListener("beforeunload", clearLocalStorage);

    return () => {
      window.removeEventListener("beforeunload", clearLocalStorage);
    };
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route
          path="/doManagerSurvey/:admin_email"
          element={<DoManagerSurvey />}
        />
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Signup />} />
        <Route path="/verifyEmail/:key" element={<ConfirmRegistration />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/resetPasswordLink/:key" element={<ResetPassword />} />
        <Route
          path="/SurveyUnavailable"
          element={
            <PrivateRoute>
              <SurveyUnavailable />
            </PrivateRoute>
          }
        />
        <Route path="/:recordId?" element={<DoSurvey />} />
        <Route path="/step1" element={<StepOne />} />
        <Route path="/step2" element={<StepTwo />} />
        <Route path="/step3" element={<StepThree />} />
        <Route path="/step4" element={<StepFour />} />
        <Route path="/step5" element={<StepFive />} />
        <Route path="/step6" element={<StepSix />} />
        <Route path="/step7" element={<Step7 />} />
        <Route path="/step8" element={<Step8 />} />
        <Route path="/step9" element={<Step9 />} />
        <Route path="/step10" element={<Step10 />} />
        <Route path="/step11" element={<Step11 />} />
        <Route path="/step12" element={<Step12 />} />
        <Route path="/step13" element={<Step13 />} />
        <Route path="/step14" element={<Step14 />} />
        <Route path="/step15" element={<Step15 />} />
        <Route path="result" element={<Result />} />
        <Route path="/ISPDashboard" element={<ISPDashboard />} />
      </Routes>
    </Router>
  );
};

export default App;
